<section class="card">
  <div class="card-header">
    <span class="cat__core__title">
      <strong>Questionnaire Review</strong>
    </span>
  </div>

  <div class="card-block watermark">
    <div class="row">
      <div class="col-lg-12">
        <div class="table-responsive table-bordered margin-bottom-50 evaluation-review-table-wrap">
          <table datatable [dtOptions]="dtOptions" id="evaluationReviewTable" [dtTrigger]="dtTrigger" class="table table-hover compact cell-border table-striped dataTable evaluation-review-table"
            style="background:transparent">
            <thead>
              <tr>
                <th class="eval-col-sr">Sr. No.</th>
                <th class="eval-col-name">Evaluation Name</th>
                <th class="eval-col-action">Action</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let evaluationReviewTypeData of evaluationReviewTypeDatas;let count=index">
                <td class="eval-col-sr">{{count + 1}}</td>
                <td class="eval-col-name">{{evaluationReviewTypeData.EvaluationFormTitle}}</td>
                <td class="eval-col-action">
                  <button type="button" class="btn btn-sm btn-primary eval-action-btn" (click)="showFormDetails(evaluationReviewTypeData)">{{checkReviewStatus(evaluationReviewTypeData)}}</button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</section>